<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">考试场地管理</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start">
          <div class="searchbox">
            <el-button type="primary" class="bgc-bv" round @click="getData()">查询</el-button>
            <el-button type="primary" class="bgc-bv" round @click="examAreaEdit()">新增</el-button>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark" :header-cell-style="tableHeader" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
              <el-table-column label="场地名称" align="left" show-overflow-tooltip prop="areaName" minWidth="200" />
              <el-table-column label="门禁标识" align="left" show-overflow-tooltip prop="gateSerial" minWidth="200" />
              <el-table-column label="场地标识" align="left" show-overflow-tooltip prop="qrHash" minWidth="200" />
              <el-table-column label="中控状态" align="left" show-overflow-tooltip prop="edgeRunnerState" minWidth="200" />
              <el-table-column label="中控版本" align="left" show-overflow-tooltip prop="edgeRunnerVer" minWidth="200" />
              <el-table-column label="报到有效期(分)" align="left" show-overflow-tooltip prop="assignedValidMinute" minWidth="200" />
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="createQrcode(scope.row)">生成新二维码</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" v-show="scope.row.qrHash" @click="browseQrcode(scope.row)">查看二维码</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="updateVerDialogShow(scope.row)">更新</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="examAreaEdit(scope.row)">编辑</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="examAreaDelete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
      </div>
    </div>
    <!-- 弹框 - 生成二维码 -->
    <el-dialog width="500px" title="生成二维码" @close="closeCode" :visible.sync="generate_QRcode_data.dialogVisible">
      <el-radio-group class="set_time" v-model="generate_QRcode_data.day" v-show="displayQrCodeSave">
        <el-radio :label="1">一天</el-radio>
        <el-radio :label="2">两天</el-radio>
        <el-radio :label="7">七天</el-radio>
        <el-radio :label="30">三十天</el-radio>
      </el-radio-group>
      <div class="qrcode">
        <!-- 放置二维码的容器,需要给一个ref -->
        <div id="qrcode" ref="qrcode"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bgc-bv" size="small" @click="createQrcode_close">取 消</el-button>
        <el-button class="bgc-bv" size="small" type="primary" v-show="displayQrCodeSave" @click="createQrcode_ok">生 成</el-button>
      </span>
    </el-dialog>
    <!-- 弹框 - 更新中控 -->
    <el-dialog width="500px" title="更新中控" @close="updateVerDialogClose" :visible.sync="updateVerData.dialogVisible">
      <el-input v-model="updateVerData.updateUrl" placeholder="请输入包下载地址"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button class="bgc-bv" size="small" type="primary" @click="updateVerDialogSave">推 送</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
import QRCode from "qrcodejs2"; // 引入qrcode
export default {
  name: "examination_examArea",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      // 发布状态 - 下拉数据
      examStateList: [],
      // 生成二维码 - 弹框数据
      generate_QRcode_data: {
        dialogVisible: false, // 弹框状态
        day: 1, // 有效时间(天)
        examAreaId: 0,
        QRcode_url: "", // 二维码地址
      },
      updateVerData: {
        dialogVisible: false, // 弹框状态
        examAreaId: 0,
        updateUrl: "", // 更新地址
      },
      displayQrCodeSave: true
    };
  },
  created() {
  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 列表数据
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
      };
      this.doFetch({
        url: "/biz/isec/exam-area/pageList",
        params,
        pageNum,
      },true,6);
    },
    // 操作 - 新增&编辑
    examAreaEdit(row) {
      this.$router.push({
        path: "/web/examination/examArea/examAreaAddEdit",
        query: {
          examAreaId: row?.examAreaId ?? ''
        }
      });
    },
    // 生成二维码
    createQrcode(row) {
      this.displayQrCodeSave = true;
      this.generate_QRcode_data.examAreaId = row.examAreaId;
      this.generate_QRcode_data.dialogVisible = true;
      this.generate_QRcode_data = { ...this.generate_QRcode_data, ...row };
      this.$nextTick(() => {
        this.$refs.qrcode.innerHTML = "";
      });
    },
    // 查看二维码
    browseQrcode(row) {
      this.generate_QRcode_data.QRcode_url = row.qrUrl;
      this.displayQrCodeSave = false;
      this.generate_QRcode_data.dialogVisible = true;
      this.generate_QRcode_data = { ...this.generate_QRcode_data, ...row };
      this.$nextTick(() => {
        this.$refs.qrcode.innerHTML = "";
        new QRCode("qrcode", {
          width: 300,
          height: 300, // 高度
          text: row.qrUrl, // 要生成二维码的链接
          render: "canvas" // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        });
      });
    },
    // 生成二维码 - 确定
    createQrcode_ok(row) {
      this.$post('/biz/isec/exam-area/initQrCode', { examAreaId: this.generate_QRcode_data.examAreaId, qrValid: this.generate_QRcode_data.day*24 }, 3000, true, 6)
        .then((res) => {
          this.$message({
            type: "success",
            message: res.message,
          });
          new QRCode("qrcode", {
            width: 300,
            height: 300, // 高度
            text: res.data.qrUrl, // 要生成二维码的链接
            render: "canvas" // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          });
          this.displayQrCodeSave = false;
        })
        .catch((err) => {
          return;
        });
    },
    // 生成二维码 - 关闭
    createQrcode_close() {
      this.generate_QRcode_data.dialogVisible = false;
      this.displayQrCodeSave = true;
    },
    updateVerDialogShow(row) {
      this.updateVerData.examAreaId = row.examAreaId;
      this.updateVerData.updateUrl = '';
      this.updateVerData.dialogVisible = true;
    },
    updateVerDialogClose() {
      this.updateVerData.dialogVisible = false;
    },
    updateVerDialogSave() {
      this.$post('/biz/isec/exam-area/updateVersion', { ...this.updateVerData }, 3000, true, 6)
        .then((res) => {
          this.$message({
            type: "success",
            message: '更新指令已经发送，请耐心等待几分钟。更新成功后可看到服务重新上线并且版本号自动更新',
          });
          this.updateVerData.dialogVisible = false;
        });
    },
    // 操作 - 删除
    examAreaDelete(row){
      // 加上是否删除的confirm弹窗
      this.$confirm("是否删除该考试场地?", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButtonClass",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post('/biz/isec/exam-area/delete', { examAreaId: row.examAreaId }, 3000, true, 6)
            .then((res) => {
              this.$message({
                type: "success",
                message: res.message,
              });
              this.getData(this.pageNum)
            })
            .catch((err) => {
              return;
            });
        })
        .catch(() => {
          return;
        });
    }
  },
};
</script>
<style lang="less" scoped>
.set_time {
  display: block;
  text-align: center;
  margin-bottom: 20px;
}
.qrcode {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 400px;
    height: 400px;
    background-color: #999; //设置白色背景色
  }
}
</style>
